import { CONFIG } from '../config'
import { HTTPService } from './http.service'

export interface IDeliveryDay {
  delivery_region_name: string
  delivery_area_name: string
  option_handle: string
  delivery_day: string
  delivery_date: string
  week: string
  cutoff_date: string
  delivery_times: IDeliveryTime[]
  cutoff: number
  tracking_cutoff_hours: number
  surcharge_price: number
}

interface IDeliveryTime {
  start_time: string
  end_time: string
}

export class DeliveryZonesService extends HTTPService {
  constructor() {
    super()
  }

  async deliveryDays(postalCode: string): Promise<IDeliveryDay[] | []> {
    try {
      const { endpoint, region, tag } = CONFIG.deliveryZones
      const response: IDeliveryDay[] = await this.post(endpoint, {
        region_code: region,
        tag,
        shipping_address: {
          postal_code: postalCode.replace(/\s/g, '')
        }
      })

      return response
    } catch (error) {
      // @TODO Log to Sentry
      return []
    }
  }
}
